import { buildKeymap } from "./keymap";
import { defaultFontMarksPlugin } from "./plugins/defaultFontMarksPlugin";
import { insertListPlugin } from "./plugins/insertListPlugin";
import { linkifyPlugin } from "./plugins/linkifyPlugin";
import { createSchema } from "./schema";
import { ProseMirrorRichTextEditorState, RichTextEditorStateKind } from "./types";
import { baseKeymap } from "prosemirror-commands";
import { history } from "prosemirror-history";
import { keymap } from "prosemirror-keymap";
import { Schema } from "prosemirror-model";
import { EditorState, Plugin } from "prosemirror-state";

export type MinimalEditorNodes =
	| "doc"
	| "paragraph"
	| "text"
	| "hard_break"
	| "orderedList"
	| "bulletList"
	| "listItem";

export type MinimalEditorMarks =
	| "link"
	| "em"
	| "underline"
	| "strikeThrough"
	| "strong"
	| "color"
	| "mention";

export type MinimalEditorSchema = Schema<MinimalEditorNodes, MinimalEditorMarks>;

export const minimalEditorSchema: MinimalEditorSchema = createSchema(
	[
		"doc",
		"paragraph",
		"text",
		"hard_break",
		"orderedList",
		"bulletList",
		"listItem"
	],
	[
		"link",
		"em",
		"underline",
		"strikeThrough",
		"strong",
		"color",
		"mention"
	]
);

const {
	"Enter": _,
	...baseKeymapWithoutEnterBinding
} = baseKeymap;

export function createInitialMinimalEditorValue(
	extraPlugins: readonly Plugin[] = []
): ProseMirrorRichTextEditorState {
	return {
		kind: RichTextEditorStateKind.ProseMirror,
		editorState: EditorState.create({
			schema: minimalEditorSchema,
			plugins: [
				insertListPlugin(minimalEditorSchema),
				linkifyPlugin(minimalEditorSchema),
				keymap(buildKeymap(minimalEditorSchema)),
				keymap(baseKeymapWithoutEnterBinding),
				history(),
				defaultFontMarksPlugin,
				...extraPlugins
			]
		})
	};
}

export const initialMinimalEditorValue: ProseMirrorRichTextEditorState = createInitialMinimalEditorValue();